module.exports = __webpack_public_path__ + "img/teepee--icon--gray.c13dfbe8.svg";